<template>
<div >
    <v-toolbar flat color="white" class= "pt-3">
        <v-btn id="locationNodeAddButtonId" color="primary" dark class="mb-2" @click="addItem()" round >Add Node</v-btn>
        <v-btn round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="locationnodes"
    worksheet="export"
    :name="'Nodes_'+new Date().getTime() / 1000+'.xls'">
    Export to Excel
</download-excel></v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        id="searchId"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

    <!-- Add new item modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <!-- Add new item modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    
    <v-dialog persistent v-model="newDialog" max-width="750px">
        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD NODE</h1>
        <v-spacer></v-spacer>
          <v-btn color="white" flat @click="close">X</v-btn>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    id="locationNodeAddNameId"
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                  <v-flex xs12 sm6 md6>
                   <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="switchingCentres"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.switchingCentreId"
                    label="*Associated Switching Centre"
                   >
               </v-autocomplete>
                </v-flex>
                <!-- <v-flex xs12 sm6 md6>
                  <v-switch v-model="editedItem.isActive"  label="isActive"></v-switch>
                </v-flex> -->
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout align-center justify-center>
              <!-- <v-btn color="primary" class="white--text" round @click="close">Cancel</v-btn> -->
            <v-btn color="primary" class="white--text" round v-if="editedItem.name &&editedItem.switchingCentreId" @click="saveNew">Save</v-btn>
            <v-btn v-else round disabled>Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

          <!-- EDIT //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
          <!-- EDIT //////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

    <v-dialog persistent v-model="dialog" max-width="750px">
        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT NODE</h1>
        <v-spacer></v-spacer>
          <v-btn color="white" flat @click="close">X</v-btn>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    id="locationNodeEditNameId"
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                   <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="switchingCentres"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.switchingCentreId"
                    label="*Associated Switching Centre"
                   >
               </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout align-center justify-center>
              <!-- <v-btn color="primary" class="white--text" round @click="close">Cancel</v-btn> -->
            <v-btn color="primary" class="white--text" round v-if="editedItem.name &&editedItem.switchingCentreId" @click="save">Save</v-btn>
            <v-btn v-else round disabled>Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
     
<v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="locationnodes"
      item-key="id"
      :key="name"
      :rows-per-page-items="[10, 25, 50, 100]"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
            <v-icon id="locationNodeEditButtonId" small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon id="locationNodeDeleteButtonId" small @click="deleteItem(props.item)">delete</v-icon>
          </td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-if="props.item.isActive===true"><v-chip small :class="`Active white--text caption my-2`">Active</v-chip></td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else><v-chip small :class="`Inactive white--text caption my-2`">InActive</v-chip></td>

      </template>
      <!-- Custom Row count and Paging text -->

      <!-- Start Here ///////////////////////////////////////////////////////////////////////// -->
      <!-- <template
        v-slot:pageText="props"
      >Records {{ recordCalculator(props.pageStart) }} - {{ recordCalculator(props.pageStop )}} of {{ totalitems }}  {{pageCount(props.itemsLength, props.pageStart, props.pageStop )}}
      </template> -->
      <!-- Expand Rows  -->
      
      <!-- No data Dispalay -->
    </v-data-table>
    <!-- <div class="text-xs-center pt-2">
      <v-btn flat  v-show="page>1" @click="pager(-1)"><v-icon>keyboard_arrow_left </v-icon> Previous</v-btn>
      <v-btn flat disabled >{{page}}</v-btn>
      <v-btn flat v-show="page<pages" @click="pager(1)">Next<v-icon>keyboard_arrow_right </v-icon> </v-btn>
    </div> -->

</div>
</template>

<script>
import Api from "@/services/Api";
import format from "date-fns/format";
export default {
  
    props:['locationnodes','totalitems','isloading'],
    data() {
        return {
            name: "",
            switchingCentres: [],
            locationNodesLength: null,
            showDetails: true,
            loading: false, 
            expand: false,
            backButton: false,
            nextButton: true,
            search: "",
            pages: "",
            totalItems: "",
            page: '',
            limit: '',
            countPerPage: [],
            rowsPerPage: 10,
            dialog: false,
            newDialog: false,
            pagination: { 
              totalItems: this.totalitems
            },
            locationNodes: [],
            locationNodesLength: [],
            editedIndex: -1,
            editedItem: {
      name: "",
      switchingCentreId:null,
      isActive: true,
      isDeleted: false
    },
    defaultItem: {
      name: "",
      switchingCentreId:null,
      isActive: true,
      isDeleted: false
    },
    headers: [
      {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
      
    ]
    }},
    
    watch: {
    dialog(val) {
      val || this.close();
    },
    
    },
    computed: {
        formTitle() {
      return this.editedIndex === -1 ? "Add Item" : "Edit Item";
    }
    },
     created() {   
     this.fetchSwitchingCentres()    
    },
    methods: {
        fetchSwitchingCentres() {
      Api()
        .get("/switchingcentres/active")
        .then(response => {
          this.switchingCentres = response.data;
        });
    },
      async routerLinkToDetails(item) {
        let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/locationNodes/:locationNodeId'})
      await this.$store.dispatch('setCurrentRoute', route[0])
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/locationNodes/" + this.editedItem.id });
    },
      recordCalculator(value){
        return(value+(Math.ceil(this.pagination.rowsPerPage*(this.page-1))))

      },
      pager(value){
        this.page=parseInt(this.page)+(parseInt(value))
        this.pagination.page=this.page
      },
      pageCount(totalItems, start, end){
        if(typeof this.page ==='undefined'){
          this.page=1
        }
        
        this.pages= Math.ceil(this.totalitems/this.pagination.rowsPerPage)
        
        
        if(((start-end)===0)&&totalItems >1){
          this.limit=this.pagination.rowsPerPage
        } else {
          this.limit= this.pagination.rowsPerPage
          this.rowsPerPage=this.limit
        }
      },
      cancelFields(){
          this.editedItem.name=""
      },
      addItem(){
        if(this.authCreate(this.$store.state.currentRoute)){
          this.newDialog=true; this.cancelFields()
        }
      },
    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedIndex = this.locationNodes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      }
    },

    deleteItem(item) {
      if(this.authDelete(this.$store.state.currentRoute)){
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/locationnodes/" + this.editedItem.id, {
          isActive: false,
          isDeleted: true
        }).then(response=>
        {this.$emit('locationNodeSaved')
        })
      }
        
        },

    close() {
      this.dialog = false;
      this.newDialog=false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },

    save() {
      let proceed = true
      if(this.editedItem.name == "")
      {proceed = false
      confirm("Please enter a name")
      }
       if(this.editedItem.switchingCentreId == null)
      {proceed = false
      confirm("Please select a switching centre")
      }
      if(proceed == true){
        
        Api().put("/locationnodes/" + this.editedItem.id, {
          name: this.editedItem.name,
          switchingCentreId: this.editedItem.switchingCentreId,
          isActive: this.editedItem.isActive,
          isDeleted: !this.editedItem.isActive
        }).then(response=>{
        this.$emit('locationNodeSaved')
        this.locationNodes.push(this.editedItem);
        this.close();
        })
      
      }
      
    },
      saveNew() {
      let proceed = true
      if(this.editedItem.name == "")
      {proceed = false
      confirm("Please enter a name")
      }
        if(this.editedItem.switchingCentreId == null)
      {proceed = false
      confirm("Please select a switching centre")
      }
      if(proceed == true){
       
        Api().post("/locationnodes", {
          name: this.editedItem.name,          
          switchingCentreId: this.editedItem.switchingCentreId,
          isActive: this.editedItem.isActive,
          isDeleted: false
        }).then(response=>{
        this.$emit('locationNodeSaved')
        this.close();
        this.$emit('locationNodeAdded');
        })
      }
      
    }
    }
        }
</script>
